import { Grid, Typography } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const TitleSubtitle = ({ title, subtitle, color, inverseTitle, titleColor, id }) => {
	return (
		<Grid
			container
			sx={{
				display: 'flex',
				flexDirection: (inverseTitle && 'column-reverse') || 'column',
			}}
		>
			{title && (
				<Grid item id={id}>
					<Typography
						variant="h3"
						color={titleColor || 'secondary'}
						sx={(theme) => ({
							fontSize: 16,
							fontWeight: 900,
							my: 2,
							textTransform: 'uppercase',
							[theme.breakpoints.down(996)]: {
								fontSize: 12,
								mt: 0,
							},
						})}
						dangerouslySetInnerHTML={{ __html: title }}
					/>
				</Grid>
			)}
			{subtitle && (
				<Grid item>
					<Typography
						variant="h4"
						color="text.primary"
						sx={(theme) => ({
							fontSize: 32,
							fontWeight: 700,
							color: color,
							[theme.breakpoints.down(996)]: {
								fontSize: 24,
								mb: 0,
							},
						})}
						dangerouslySetInnerHTML={{ __html: subtitle }}
					/>
				</Grid>
			)}
		</Grid>
	)
}
TitleSubtitle.defaultProps = {
	title: '',
	subtitle: '',
	color: 'black',
	inverseTitle: false,
}

TitleSubtitle.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	color: PropTypes.string,
	inverseTitle: PropTypes.bool,
}
export default TitleSubtitle
